import { Box } from '@material-ui/core'
import { Stack } from '@mui/material'
import TemplateCard from 'components/TemplateCard'
import React, { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'utils/notify'
import { updateConfigById } from 'store/config'
import { TemplateNames } from 'views/admin/configuration/Configuration/constants'

export const Templates = ({ config }) => {
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false)

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const templates = useMemo(() => {
    return {
      [TemplateNames.welcomeEmail.id]: {
        id: TemplateNames.welcomeEmail.id,
        name: TemplateNames.welcomeEmail.name,
        subject: config?.[TemplateNames.welcomeEmail.subjectKey] || '',
        body: config?.[TemplateNames.welcomeEmail.bodyKey] || ''
      }
    }
  }, [config])

  const onSaveTemplates = (newValues, closeModal) => {
    startLoading()
    dispatch(
      updateConfigById(
        config?.id,
        {
          [TemplateNames.welcomeEmail.subjectKey]: newValues.subject?.trim(),
          [TemplateNames.welcomeEmail.bodyKey]: newValues.body?.trim()
        },
        () => {
          toast.success('Settings saved.')
          stopLoading()
          closeModal()
        },
        () => {
          toast.error('Could not save template. Try again.')
          stopLoading()
        }
      )
    )
  }

  return (
    <Box>
      <Stack gap={2} mt={2}>
        {Object.values(templates).map((item) => (
          <TemplateCard
            key={item.id}
            template={templates[item.id]}
            onSaveTemplate={onSaveTemplates}
            isLoading={isLoading}
            templateId={item.id}
          />
        ))}
      </Stack>
    </Box>
  )
}

export default Templates
